// Source de vérité canonique — Correspondance protocolaire OHADA (Cockpit Avocat V2).
//
// Miroir de backend/core/correspondance_canonical.py (16 types / 8 statuts /
// 4 visibilités). Toute évolution doit rester alignée des deux côtés.

export type TypeMessage =
  | "CONSTITUTION"
  | "TRANSMISSION_PIECES"
  | "SOMMATION_COMMUNIQUER"
  | "COMMUNICATION_CONCLUSIONS"
  | "PROPOSITION_CALENDRIER"
  | "DEMANDE_DELAI"
  | "PROPOSITION_TRANSACTION"
  | "OBSERVATIONS"
  | "INCIDENT_PROCEDURE"
  | "DEMANDE_RECUSATION"
  | "DEMANDE_MESURE_PROVISOIRE"
  | "CONVOCATION_REUNION"
  | "ACCUSE_RECEPTION"
  | "ACQUIESCEMENT"
  | "CONTESTATION"
  | "AUTRE";

export type StatutMessage =
  | "BROUILLON"
  | "ENVOYE"
  | "DELIVRE"
  | "LU"
  | "ACCUSE_RECEPTION"
  | "REPONDU"
  | "ARCHIVE"
  | "RETIRE";

export type VisibiliteMessage =
  | "CONFIDENTIEL"
  | "INTER_AVOCATS"
  | "COPIE_TRIBUNAL"
  | "REQUIS_TRIBUNAL";

export const TYPES_MESSAGE: { value: TypeMessage; label: string }[] = [
  { value: "CONSTITUTION", label: "Constitution du tribunal" },
  { value: "TRANSMISSION_PIECES", label: "Transmission de pièces" },
  { value: "SOMMATION_COMMUNIQUER", label: "Sommation de communiquer" },
  { value: "COMMUNICATION_CONCLUSIONS", label: "Communication de conclusions" },
  { value: "PROPOSITION_CALENDRIER", label: "Proposition de calendrier" },
  { value: "DEMANDE_DELAI", label: "Demande de délai" },
  { value: "PROPOSITION_TRANSACTION", label: "Proposition de transaction" },
  { value: "OBSERVATIONS", label: "Observations" },
  { value: "INCIDENT_PROCEDURE", label: "Incident de procédure" },
  { value: "DEMANDE_RECUSATION", label: "Demande de récusation" },
  { value: "DEMANDE_MESURE_PROVISOIRE", label: "Mesure provisoire" },
  { value: "CONVOCATION_REUNION", label: "Convocation à une réunion" },
  { value: "ACCUSE_RECEPTION", label: "Accusé de réception" },
  { value: "ACQUIESCEMENT", label: "Acquiescement" },
  { value: "CONTESTATION", label: "Contestation" },
  { value: "AUTRE", label: "Autre (justification obligatoire)" },
];

export const STATUTS_MESSAGE: Record<StatutMessage, string> = {
  BROUILLON: "Brouillon",
  ENVOYE: "Envoyé",
  DELIVRE: "Délivré",
  LU: "Lu",
  ACCUSE_RECEPTION: "Accusé de réception",
  REPONDU: "Répondu",
  ARCHIVE: "Archivé",
  RETIRE: "Retiré",
};

export const VISIBILITES: Record<VisibiliteMessage, string> = {
  CONFIDENTIEL: "Confidentiel",
  INTER_AVOCATS: "Inter-avocats",
  COPIE_TRIBUNAL: "Copie tribunal",
  REQUIS_TRIBUNAL: "Requis tribunal",
};

// Transitions de statut autorisées (machine à états canonique).
export const TRANSITIONS: Record<StatutMessage, StatutMessage[]> = {
  BROUILLON: ["ENVOYE", "RETIRE"],
  ENVOYE: ["DELIVRE", "RETIRE"],
  DELIVRE: ["LU"],
  LU: ["ACCUSE_RECEPTION", "REPONDU"],
  ACCUSE_RECEPTION: ["REPONDU", "ARCHIVE"],
  REPONDU: ["ARCHIVE"],
  ARCHIVE: [],
  RETIRE: [],
};

// Visibilité par défaut par type.
export const VISIBILITE_DEFAUT: Record<TypeMessage, VisibiliteMessage> = {
  CONSTITUTION: "REQUIS_TRIBUNAL",
  TRANSMISSION_PIECES: "COPIE_TRIBUNAL",
  SOMMATION_COMMUNIQUER: "INTER_AVOCATS",
  COMMUNICATION_CONCLUSIONS: "COPIE_TRIBUNAL",
  PROPOSITION_CALENDRIER: "REQUIS_TRIBUNAL",
  DEMANDE_DELAI: "REQUIS_TRIBUNAL",
  PROPOSITION_TRANSACTION: "INTER_AVOCATS",
  OBSERVATIONS: "COPIE_TRIBUNAL",
  INCIDENT_PROCEDURE: "REQUIS_TRIBUNAL",
  DEMANDE_RECUSATION: "REQUIS_TRIBUNAL",
  DEMANDE_MESURE_PROVISOIRE: "REQUIS_TRIBUNAL",
  CONVOCATION_REUNION: "REQUIS_TRIBUNAL",
  ACCUSE_RECEPTION: "INTER_AVOCATS",
  ACQUIESCEMENT: "COPIE_TRIBUNAL",
  CONTESTATION: "COPIE_TRIBUNAL",
  AUTRE: "COPIE_TRIBUNAL",
};

// Types pour lesquels la visibilité est imposée (l'arbitre doit agir).
export const TYPES_VISIBILITE_BLOQUANTE: TypeMessage[] = [
  "CONSTITUTION",
  "INCIDENT_PROCEDURE",
  "DEMANDE_RECUSATION",
  "DEMANDE_MESURE_PROVISOIRE",
  "DEMANDE_DELAI",
];

export function typeMessageLabel(v: string | null | undefined): string {
  if (!v) return "Message";
  return TYPES_MESSAGE.find((t) => t.value === v)?.label ?? v;
}

export function visibiliteImposee(type: TypeMessage): boolean {
  return TYPES_VISIBILITE_BLOQUANTE.includes(type);
}
